import { Phone, Users } from "lucide-react";

export default function EmergencyCare() {
  return (
    <section data-testid="emergency-section" className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img src="/images/emergency-bg.webp" alt="" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-[#0a6b60]/85" />
      </div>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="reveal-left text-left">
            <p className="text-white/60 text-sm font-medium mb-3 tracking-widest uppercase">Need Emergency Care</p>
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-[2.75rem] text-white tracking-tight leading-tight mb-5">Don't Hesitate To Contact Us Now</h2>
            <p className="text-white/75 text-base md:text-lg leading-relaxed mb-8 max-w-xl">In case of a surgical emergency, Dr. Dileep Sunkavalli and his experienced team at Vijayawada are available for immediate consultation and urgent surgical procedures.</p>
            <div className="bg-[#084d44] rounded-xl p-5 inline-flex items-center gap-4 border border-white/10 shadow-lg">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0"><Phone className="w-6 h-6 text-white" strokeWidth={1.5} /></div>
              <div><p className="text-white/70 font-medium text-sm">For Any Emergency Case</p><a href="tel:+919703300455" className="text-white font-heading font-bold text-xl md:text-2xl hover:text-teal-light transition-colors">Call us at: 7075659696</a></div>
            </div>
          </div>
          <div className="reveal-right relative flex justify-center lg:justify-end">
            <div className="relative max-w-sm md:max-w-md">
              <img src="/images/emergency-care.webp" alt="Emergency surgical care available" className="w-full rounded-2xl shadow-2xl" loading="lazy" />
              <div className="absolute -top-4 -left-4 md:top-0 md:-left-6 bg-white rounded-xl shadow-lg px-4 py-3 border border-slate-100">
                <div className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-full bg-amber-50 flex items-center justify-center flex-shrink-0"><Users className="w-4 h-4 text-amber-500" strokeWidth={1.5} /></div>
                  <div><p className="font-heading font-bold text-navy text-sm leading-tight">Trusted by</p><p className="text-teal font-bold text-sm leading-tight">8000+ patients</p></div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 md:bottom-0 md:-right-6 bg-white rounded-xl shadow-lg px-4 py-3 border border-slate-100">
                <p className="font-heading font-semibold text-navy text-xs mb-2">Expert Surgical Skills</p>
                <div className="flex items-end gap-[3px] h-8">
                  {[40,65,45,80,55,70,90,60,75,85,50,72].map((h,i) => (<div key={i} className={`w-[5px] rounded-sm ${i%3===0?"bg-amber-400":"bg-teal"}`} style={{height:`${h}%`}} />))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
